import { Injectable } from '@angular/core';
import { ExplanationMessage } from './explanation-message';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ExplanationService {

  private openExplanationSource = new Subject<number>();
  public openExplanation$ = this.openExplanationSource.asObservable();

  private setExplanationSource = new Subject<string>();
  public setExplanationSource$ = this.setExplanationSource.asObservable()

  constructor() { }

  public openExplanation(pageNumber) {
    this.openExplanationSource.next(pageNumber);
  }

  public setExplanationSourceUrl(id: string) {
      this.setExplanationSource.next(id);
  }
}



// WEBPACK FOOTER //
// ./src/app/examination/explanation.service.ts